import { ConfirmDialog } from "~/ui/common/Modal/ConfirmDialog";

export const ConfirmEmailChangeModal = ({
  show,
  firstName,
  currentEmail,
  newEmail,
  isSaving,
  onConfirm,
  onClose,
}: {
  show: boolean;
  firstName: string;
  currentEmail: string;
  newEmail: string;
  isSaving: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) => (
  <ConfirmDialog
    show={show}
    title="Confirm email change"
    description={
      <>
        Update {firstName}&apos;s hub account email from{" "}
        <span className="font-semibold">{currentEmail}</span> to:
      </>
    }
    confirmLabel="Save changes"
    isLoading={isSaving}
    onConfirm={onConfirm}
    onCancel={onClose}
  >
    <p className="bg-placebo-lavender text-indigo rounded-md p-3 text-lg font-medium">
      {newEmail}
    </p>

    <p className="text-dark-blue-gray text-base">
      A verification email will be sent upon confirmation. Changing this email
      will not update the email stored in Athena.
    </p>
  </ConfirmDialog>
);
